<template>
    <div :style="{'height': useCaseHeight + 'px'}">
        <vxe-table
                stripe
                highlight-hover-row
                border
                resizable
                show-overflow
                class="sortable-row-demo"
                height="auto"
                auto-resize
                size="mini"
                :data="tableData">
            <template v-slot:empty>
                <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
            </template>
            <vxe-table-column  min-width="100" field="action_type">
                <template v-slot:header>
                    <a-tooltip placement="topLeft">
                        <template slot="title">
                            <span class="fontWeight6">Action Type</span>
                        </template>
                        <span class="fontWeight6">Action Type</span>
                    </a-tooltip>
                </template>
            </vxe-table-column>
            <vxe-table-column  min-width="100" field="do_id">
                <template v-slot:header>
                    <a-tooltip placement="topLeft">
                        <template slot="title">
                            <span class="fontWeight6">Do ID</span>
                        </template>
                        <span class="fontWeight6">Do ID</span>
                    </a-tooltip>
                </template>
            </vxe-table-column>
            <vxe-table-column  min-width="100" field="line_no">
                <template v-slot:header>
                    <a-tooltip placement="topLeft">
                        <template slot="title">
                            <span class="fontWeight6">Line No</span>
                        </template>
                        <span class="fontWeight6">Line No</span>
                    </a-tooltip>
                </template>
            </vxe-table-column>
            <vxe-table-column  min-width="100" field="route_id" show-overflow>
                <template v-slot:header>
                    <a-tooltip placement="topLeft">
                        <template slot="title">
                            <span class="fontWeight6">Route ID</span>
                        </template>
                        <span class="fontWeight6">Route ID</span>
                    </a-tooltip>
                </template>
            </vxe-table-column>
            <vxe-table-column  min-width="100" field="status" show-overflow>
                <template v-slot:header>
                    <a-tooltip placement="topLeft">
                        <template slot="title">
                            <span class="fontWeight6">Status</span>
                        </template>
                        <span class="fontWeight6">Status</span>
                    </a-tooltip>
                </template>
            </vxe-table-column>
        </vxe-table>
    </div>
</template>
<script>
    import ajax from '../../api/ajax'
    import api from '../../api/url'
    export default{
        data(){
            return{
                tableData:[],
            }
        },
        props:{
            useCaseHeight:{
                type: Number,
                default: () => {
                    return 150;
                }
            },
            useCase3TableUid:{
                type: String,
                default: () => {
                    return null;
                }
            }
        },
        watch:{
            useCase3TableUid(){
                this.init()
            }
        },
        created(){
            this.init()
        },
        methods:{
            init(){
                if(this.useCase3TableUid){
                    ajax.get(api.TMSGETWAYORDERS,{uid: this.useCase3TableUid}).then(res=>{
                       this.tableData = res.data
                    })
                }else{
                    this.tableData = []
                }
            }
        }
    }
</script>
<style>
    .vxe-header--column .vxe-cell--title{
        line-height:2.5;
    }
</style>